import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";

import DesignSystemLayout from "components/DesignSystemPage/DesignSystemLayout";
import CommonEditor from "components/CommonEditor";

import "assets/scss/pages/DesignSystem.scss";
import EmptyPage from "./EmptyPage";

const ContentPage = () => {
  const { id, pageId } = useParams();
  const [page, setPage] = useState("");
  const [pages, setPages] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [bannerImage, setBannerImage] = useState("");
  const { designSystemMeta } = useGlobalContext();
  const navigate = useNavigate();
  useEffect(() => {
    let currentPage = {};
    if (designSystemMeta?.pages) {
      const contentPages = designSystemMeta.pages.filter(
        (page) => page.type == "content"
      );
      setPages(contentPages);

      currentPage = designSystemMeta.pages.find(
        (page) => page.type == "content"
      );
      setPage(currentPage);
    }
    if (pageId === "home") {
      navigate(`/${id}/content/${currentPage?.id}`);
    }
  }, [designSystemMeta]);

  const bannerData = {
    heading: designSystemMeta?.design_system_name,
    description:
      "Foundations inform the basis of any great user interface, from accessibility standards to essential patterns for layout and interaction.",
    bannerImage: designSystemMeta.banner_url,
  };

  let sideTabs = pages?.map((page) => {
    return { title: page.name, link: `/${id}/content/${page.id}`, page: page };
  });

  const tabs = ["Content"];

  return (
    <DesignSystemLayout
      designSystemName={designSystemMeta?.design_system_name}
      bannerData={bannerData}
      tabs={tabs}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      setBannerImage={setBannerImage}
      sideTabs={sideTabs}
      title="Content"
    >
      {page ? <CommonEditor page={page} /> : <EmptyPage type="content" />}
    </DesignSystemLayout>
  );
};

export default ContentPage;
